module.exports = "images/service_icon_03.svg";